module.exports = __webpack_public_path__ + "img/vanampadi.72a61d15.jpg";